import * as Yup from 'yup'

const customMessageValidator = Yup.object ({
  title: Yup.string ()
    .required ('Digite um título')
    .min (4, 'O título deve conter no minimo 4 caracteres')
    .max (128, 'O título deve conter até 128 caracteres'),
    
  content: Yup.string ()
    .required ('Digite o conteúdo da mensagem')
    .max (1024, 'O conteúdo deve conter até 1024 caracteres')
})

export default customMessageValidator
